export const Type = {
  SUBMIT_LOGIN: "submitLogin",
  SUBMIT_LOGIN_SELLER: "submitLoginSeller",
  SUBMIT_LOGIN_SUCCESS: "submitLoginSuccess",
  RDIRECT_TO_LOGIN_SELLER: "rdirectToLoginSeller",
  LOGOUT: "logout",
};
